<div class="wrapper">
  <div class="file-upload-wrapper" (fileDropped)="onFileDropped($event)" appFileDragAndDrop>
    <div class="file-upload-label">{{ inputDetails().displayName }}</div>
    <div class="file-upload">
      <div class="file-upload-value drop-zone">
        @if (files.length > 0) {
          <div class="file-button-wrapper">
            @for (file of files; track file; let i = $index) {
              <div>
                <button
                  type="button"
                  (click)="removeFile(i)"
                  mat-flat-button
                  matTooltip="Click to delete"
                  [disabled]="!isSelectable">
                  {{ file.name }}
                  <mat-icon color="primary">delete</mat-icon>
                </button>
              </div>
            }
          </div>
        }
        @if (files.length === 0) {
          <div>No file uploaded yet. Drag and drop file or browse.</div>
        }
      </div>

      <button
        type="button"
        (click)="fileUpload.click()"
        class="file-upload-btn"
        color="primary"
        mat-mini-fab
        [disabled]="!isSelectable">
        <mat-icon>attach_file</mat-icon>
      </button>
    </div>
  </div>
  <div class="help-icon">
    <mat-icon [matTooltip]="inputDetails().description" color="primary">help </mat-icon>
  </div>
  <input
    #fileUpload
    (change)="onFileSelected($event)"
    [accept]="acceptedFileTypes()"
    class="file-input"
    multiple="{{ isList() ? 'multiple' : '' }}"
    type="file" />
</div>
